export default __webpack_public_path__ + "static/hub-safety-goggles-bab7396e997fc61c33555db622f5a84b.jpg";